
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import TitelDetail from '@/components/Titel/TitelDetail.vue';
    import TitelType from '@/types/Titel';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            TitelDetail,
        },
        computed: {
            ...mapState('titel', ['dialogs', 'loaders']),
            ...mapState('titel', { titelListe: 'titel' }),
        },
        methods: {
            ...mapActions('titel', ['loadTitel']),
            ...mapMutations('titel', ['setDialogsDetail']),
        },
    })
    export default class Titel extends Vue {
        public loadTitel!: () => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public titel = new TitelType();
        public search = '';

        public get headers(): DataTableHeaders<TitelType> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Titel', value: 'titel' },
            ];
        }

        public mounted(): void {
            this.loadTitel();
        }

        public onClickEdit(titel: TitelType): void {
            this.titel = new TitelType(titel);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.titel = new TitelType();
            this.setDialogsDetail(true);
        }
    }
